import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import Categories from "./categories/Categories";
import ProductList from "./productlist/ProductList";
import ProductDetail from "./productdetail/ProductDetail";
import BasketStore from "./basketdetail/BasketStore";
import ReceiptOrder from "./finishorder/ReceiptOrder";
import SuccessOrder from "./finishorder/SuccessOrder";
import Dropin from "./finishorder/Dropin";
import LobbyRowHome from "./lobbyrow/LobbyRowHome";
import FulfillmentDetail from "./lobbyrow/FulfillmentDetail";
import SuccessFulfillment from "./lobbyrow/SuccessFulfillment";
import SuccessOrderPolling from "./finishorder/SuccessOrderPolling";
import HotelkeyPolling from "./finishorder/HotelkeyPolling";
import WindcavePolling from "./precheckin/WindcavePolling";
import { PreCheckInContextProvider } from "./precheckin/contexts/PreCheckInContext";
import PreCheckInApp from "./routes/PreCheckInApp";

function RootContainer() {
  let query = new URLSearchParams(useLocation().search);
  let uid = query.get("uid");
  return (
    <>
      <Switch>
        <Route exact path={"/"} component={Categories} />
        <Route
          exact
          path={"/store"}
          render={(props) => <Categories {...props} storeId={uid} />}
        />
        <Route
          exact
          path={"/category"}
          render={(props) => <ProductList {...props} categoryId={uid} />}
        />
        <Route
          exact
          path={"/categories/:categoryId/products"}
          component={ProductList}
        />
        <Route
          exact
          path={"/categories/:categoryId/products/:productId"}
          component={ProductDetail}
        />
        <Route
          exact
          path={"/categories/:categoryId/basket"}
          component={BasketStore}
        />
        <Route exact path={"/receipt"} component={ReceiptOrder} />
        <Route exact path={"/success"} component={SuccessOrder} />
        <Route exact path={"/dropin"} component={Dropin} />
        <Route
          exact
          path={"/success_polling"}
          component={SuccessOrderPolling}
        />
        <Route exact path={"/hotelkey-payment"} component={HotelkeyPolling} />
        <Route exact path={"/windcave-polling"} component={WindcavePolling} />
        <Route
          exact
          path={"/:propertyUid/lobby/:lobbyId"}
          component={LobbyRowHome}
        />
        <Route
          exact
          path={"/:propertyUid/lobby/:lobbyId/fulfillments/:fulfillmentId"}
          component={FulfillmentDetail}
        />
        <Route
          exact
          path={
            "/:propertyUid/lobby/:lobbyId/fulfillments/:fulfillmentId/success"
          }
          component={SuccessFulfillment}
        />
        <PreCheckInContextProvider>
          <PreCheckInApp />
        </PreCheckInContextProvider>
      </Switch>
    </>
  );
}

export default RootContainer;
